module.exports = __webpack_public_path__ + "img/method-icon-big.6ad5b052.png";